import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

// Paski systemowe sa widoczne. Na sciezce "padding" plugin safe-area paduje decorView
// (WebView zaczyna sie juz pod paskiem) i ustawia env=0 — wtedy dodatkowy odstep bylby
// redundantny (podwojna przerwa). Na sciezce passthrough env = realna wysokosc paska.
// Dlatego uzywamy samego env, bez sztywnego floora (ten byl tylko dla starego immersive).
const PADDING_TOP = isNative
  ? 'env(safe-area-inset-top)'
  : 'calc(env(safe-area-inset-top) + 6px)';

const PADDING_BOTTOM = 'env(safe-area-inset-bottom)';

export const useAndroidSafeArea = () => ({
  paddingTop: PADDING_TOP,
  paddingBottom: PADDING_BOTTOM,
});
